<template>
  <transition name="modal" v-if="show">
    <div class="modal-mask" v-cloak>
      <div class="modal-wrapper">
        <div
          class="modal-container"
          v-click-outside="close"
          :class="container_class"
          :style="container_style"
        >
          <div class="modal-close" @click="close">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.99986 5.77131L2.26534 0.0366211L0.500805 1.80121L6.23533 7.53589L0.499512 13.2719L2.26405 15.0365L7.99986 9.30048L13.7348 15.0356L15.4994 13.271L9.7644 7.53589L15.4981 1.80206L13.7335 0.0374778L7.99986 5.77131Z"
                fill="#34312E"
              />
            </svg>
          </div>
          <slot :modalProps="modalProps" :close="close"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { ModalBus } from "@/vue/config/eventBus";

export default {
  name: "modal",
  data() {
    return {
      modalProps: null,
      show: false,
    };
  },
  props: {
    container_class: String,
    container_style: [String, Object],
    id: [String, Number],
  },
  watch: {
    show(modalOpen) {
      if (modalOpen) {
        document.documentElement.style.overflow = "hidden";
        return;
      }

      document.documentElement.style.overflow = "auto";
    },
  },
  methods: {
    close() {
      this.show = false;
    },
    handleKeyup(e) {
      if (e.keyCode === 27) this.close();
    },
  },
  created() {
    document.addEventListener("keyup", this.handleKeyup);
  },
  beforeDestroy() {
    document.removeEventListener("keyup", this.handleKeyup);
  },
  mounted() {
    const component = this;
    ModalBus.$on("toggle", function (modalId, additionalModalProps) {
      if (modalId === component.id) {
        component.modalProps = additionalModalProps;
        component.show = !component.show;
      }
    });
  },
};
</script>
